const colors = {
  white: {
    main: '#FFFFFF',
    transparent: '#ffffff0f',
  },
  black: {
    main: '#001011',
    transparent: '#000000b5',
  },
  grey: {
    main: '#8E8E93',
    light: '#CCCCCC',
    lighter: '#e5e5e5',
    lightest: '#eeeeee',
    transparent: 'rgba(0, 0, 0, 0.4)',
  },
  green: {
    main: '#00CB87',
    light: '#89eac9',
    lighter: '#D7F6EC',
    lightest: '#f4fcfa',
  },
  blue: {
    main: '#16A4E7',
    light: '#a8e2ff',
    lighter: '#e9f8ff',
  },
  orange: {
    main: '#F5A623',
  },
  // GENERAL COLOURS
  transparent: 'transparent',
};

export default {
  app: {
    appBackground: colors.white.main,
    pageBackground: colors.transparent,
    contentBackground: colors.transparent,
  },
  primary: {
    main: colors.green.main,
    light: colors.green.light,
    lighter: colors.green.lighter,
    lightest: colors.green.lightest,
    text: colors.black.main,
    textOn: colors.white.main,
    widgetOnBackground: colors.white.main,
  },
  secondary: {
    main: colors.grey.main,
    light: colors.grey.light,
    lighter: colors.grey.lighter,
    lightest: colors.grey.lightest,
    text: colors.grey.main,
    textOn: colors.white.main,
    widgetOnBackground: colors.white.main,
  },
  tertiary: {
    main: colors.blue.main,
    light: colors.blue.light,
    lighter: colors.blue.lighter,
    text: colors.green.main,
    textOn: colors.white.main,
    widgetOnBackground: colors.white.main,
  },
  standout: {
    text: colors.orange.main,
  },
  status: {
    success: colors.green.main,
  },
  transparent: {
    light: colors.white.transparent,
    notSoDark: colors.grey.transparent,
    dark: colors.black.transparent,
  },
};
